import { Paperclip } from "lucide-react";
import { useTranslation } from "react-i18next";
import DocumentSidePreview from "./DocumentSidePreview";

export interface DocumentAttachmentItem {
  label?: string;
  url: string;
}

interface DocumentAttachmentsProps {
  items: DocumentAttachmentItem[];
  onDownload?: (url: string) => void;
  onPreview?: (url: string) => void;
  title?: string;
  emptyMessage?: string;
}

const DocumentAttachments = ({
  items,
  onDownload,
  onPreview,
  title,
  emptyMessage,
}: DocumentAttachmentsProps) => {
  const { t } = useTranslation("common");
  if (items.length === 0 && !emptyMessage) return null;

  return (
    <div className="mt-6 pt-6 border-t border-border-border-strong">
      <div className="flex items-center gap-2 mb-4">
        <Paperclip className="w-3.5 h-3.5 text-muted-foreground" />
        <h5 className="font-medium">
          {title ?? t("common:shared_ui.uploaded_documents")}
        </h5>
        {items.length > 0 && (
          <span className="text-[11px] font-semibold text-muted-foreground bg-muted px-2 py-0.5 rounded-full">
            {items.length}
          </span>
        )}
      </div>

      {items.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-2 px-4 py-8 text-center border border-dashed border-border rounded-sm bg-gray-50/60">
          <Paperclip className="w-5 h-5 text-gray-300" />
          <p className="text-sm text-muted-foreground">{emptyMessage}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {items.map(({ label, url }) => (
            <DocumentSidePreview
              key={url}
              label={label}
              url={url}
              onDownload={onDownload}
              onPreview={onPreview}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentAttachments;
